import React, { FC } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { useUserInfoState } from 'src/front/contexts/SessionContext';

import Layout from 'src/front/pages/Layout';
import { LOGIN } from './paths';

interface PrivateRouteProps {
  path: string;
  component: FC;
  exact: boolean;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ path, component, exact }) => {
  const { isLoggedIn } = useUserInfoState();

  return isLoggedIn ? (
    <Layout>
      <Route component={component} exact={exact} path={path} />
    </Layout>
  ) : (
    <Redirect to={LOGIN} />
  );
};

export default PrivateRoute;
